import type { LayoutQuery } from '#graphql-operations'
import localize from '~layers/utils/localize.ts'

type TooltipItem = NonNullable<NonNullable<LayoutQuery['tooltips']>[number]>

export function useLayout() {
  const { public: config } = useRuntimeConfig()
  const originalLayoutData = useState<LayoutQuery | null>('layout', () => null)

  const layoutData = computed(() => localize(originalLayoutData.value))

  const loadLayout = async () => {
    if (!layoutData.value) {
      const { data } = await useAsyncGraphqlQuery('layout', {
        locale: config.strapiLocale,
      }, useGraphqlDefaultClient())
      originalLayoutData.value = data.value?.data || null
    }
  }

  const tooltips = computed<Map<string, TooltipItem>>(() => {
    const data = new Map<string, TooltipItem>()
    layoutData.value?.tooltips?.forEach((tooltip) => {
      if (tooltip?.UID) {
        data.set(tooltip.UID, tooltip)
      }
    })
    return data
  })

  return {
    loadLayout,
    layoutData,
    tooltips,
  }
}
